import React from 'react'

import { Sparkle } from 'lucide-react'

interface CardHeaderProps {
  number?: number
}

const CardHeader = ({ number }: CardHeaderProps) => {
  if (!number) {
    return (
      <div className="absolute top-4 right-4">
        <Sparkle className="h-4 w-4 text-[#B360D4]" />
      </div>
    )
  }

  return (
    <div className="mb-2 flex items-center justify-between">
      <div className="w-6 h-6 bg-[#F5F6F7] dark:bg-gray-800 rounded-[4px] flex items-center justify-center shrink-0">
        <span className="text-base font-semibold text-[#62718D] dark:text-gray-300">{number}</span>
      </div>
      <div>
        <Sparkle className="h-4 w-4 text-[#B360D4]" />
      </div>
    </div>
  )
}

export default CardHeader
